import { render, staticRenderFns } from "./DialogShortKey.vue?vue&type=template&id=5d48d748"
import script from "./DialogShortKey.vue?vue&type=script&lang=js"
export * from "./DialogShortKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports